import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { config } from '../../shared/smartadmin.config';
import { AppState } from '../../app.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private http: HttpClient, public appState: AppState) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
      if (localStorage.getItem('authToken') != null || sessionStorage.getItem('authToken') != null) {
        const token = localStorage.getItem('authToken') ? localStorage.getItem('authToken') : sessionStorage.getItem('authToken');
        const headers = new HttpHeaders().set('authorization', token);
        headers.append('Content-Type', 'application/json');
        return this.http.get(config.URL + '/profile/getProfile', {headers: headers, withCredentials: true}).map((data: any) => {
          this.appState.set('role', data.role);
          this.appState.set('customer', data.customer);
          this.appState.set('username', data.name + ' ' + data.lastname)
          this.appState.set('theme', data.theme);
          this.appState.set('type', data.customerType);
          this.appState.set('gatemaster', data.gatemasterId);
          return true;
        }, (err) => {
          console.log(err);
          return false;
        })
      } else {
        this.router.navigate(['/auth/login']);
        return false;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth.guard.ts